// Positive reviews carousel: center overlay controls and hide at edges
document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.positive-reviews-video-wrapper').forEach(wrapper => {
      const scroller = wrapper.querySelector('.positive-reviews-video-blocks');
      const prev = wrapper.querySelector('.carousel-btn.prev');
      const next = wrapper.querySelector('.carousel-btn.next');
      if (!scroller || !prev || !next) return;
      function getGap() {
        const style = window.getComputedStyle(scroller);
        const gap = parseFloat(style.columnGap || style.gap || '0');
        return isNaN(gap) ? 0 : gap;
      }
      function getScrollAmount() {
        const first = scroller.querySelector('.positive-review-video');
        if (first) {
          const rect = first.getBoundingClientRect();
          return Math.ceil(rect.width + getGap()) || 300;
        }
        return 300;
      }
      function atStart() { return Math.round(scroller.scrollLeft) <= 1; }
      function atEnd() {
        const maxScroll = scroller.scrollWidth - scroller.clientWidth - 1;
        return Math.round(scroller.scrollLeft) >= maxScroll;
      }
      function updateButtons() {
        const start = atStart();
        const end = atEnd();
        prev.disabled = start;
        next.disabled = end;
        prev.style.display = start ? 'none' : '';
        next.style.display = end ? 'none' : '';
      }
      prev.addEventListener('click', () => {
        const amount = getScrollAmount();
        const target = Math.max(0, scroller.scrollLeft - amount);
        scroller.scrollTo({ left: target, behavior: 'smooth' });
        setTimeout(updateButtons, 300);
      });
      next.addEventListener('click', () => {
        scroller.scrollBy({ left: getScrollAmount(), behavior: 'smooth' });
        setTimeout(updateButtons, 300);
      });
      scroller.addEventListener('scroll', updateButtons, { passive: true });
      window.addEventListener('resize', updateButtons);
      try { prev.disabled = true; prev.style.display = 'none'; } catch(e) {}
      updateButtons();
      requestAnimationFrame(updateButtons);
      window.addEventListener('load', updateButtons);
    });
  });
  